import { render, staticRenderFns } from "./webSocialProofEditor.vue?vue&type=template&id=36bdd9e5&"
import script from "./webSocialProofEditor.vue?vue&type=script&lang=js&"
export * from "./webSocialProofEditor.vue?vue&type=script&lang=js&"
import style0 from "./webSocialProofEditor.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports